import React from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { GlowButton } from '../../components/ui/GlowButton';
import { GlassCard } from '../../components/ui/GlassCard';
import { AnalyticsDashboard } from '../../components/AnalyticsDashboard';
import { ResultsSection } from '../../components/ResultsSection';
export function LandingPageIN() {
  const navigate = useNavigate();
  const handleBookingClick = () => {
    navigate('/in/booking');
  };
  return <main className="min-h-screen w-full bg-background text-foreground bg-noise selection:bg-blue-500/30 overflow-x-hidden" data-id="element-192">
      {/* Announcement Bar */}
      <div className="w-full bg-gradient-to-r from-blue-900/40 to-purple-900/40 backdrop-blur-md border-b border-white/5 py-2 px-4 text-center relative z-50" data-id="element-193">
        <p className="label-caps text-[10px] md:text-[11px] text-white/80 flex items-center justify-center gap-2 tracking-[0.1em]" data-id="element-194">
          <span className="text-sm" data-id="element-195">🇮🇳</span>
          <span data-id="element-196">Exclusive for Indian Creators — Limited Spots Open</span>
        </p>
      </div>

      {/* Hero Section */}
      <section className="relative min-h-0 lg:min-h-[85vh] flex items-center px-4 md:px-8 py-10 md:py-16 overflow-hidden" data-id="element-197">
        <div className="absolute top-0 right-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-blue-600/10 rounded-full blur-[80px] md:blur-[120px] translate-x-1/3 -translate-y-1/4 animate-float pointer-events-none" data-id="element-198" />
        <div className="absolute bottom-0 left-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-purple-600/10 rounded-full blur-[80px] md:blur-[120px] -translate-x-1/3 translate-y-1/4 animate-float-delayed pointer-events-none" data-id="element-199" />

        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10" data-id="element-200">
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-201">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-6 animate-fade-in-up" data-id="element-202">
              <span className="relative flex h-2 w-2" data-id="element-203">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-204"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-205"></span>
              </span>
              <span className="label-caps text-[10px] sm:text-[11px] text-gray-400" data-id="element-206">
                Faceless YouTube System — India
              </span>
            </div>

            <h1 className="animate-fade-in-up delay-100 mb-4" data-id="element-207">
              <span className="text-white block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black tracking-[-0.03em] leading-[1.08]" data-id="element-208">
                Build a Profitable
              </span>
              <span className="text-gradient block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black tracking-[-0.03em] leading-[1.08] mt-0.5" data-id="element-209">
                Faceless YouTube Channel
              </span>
              <span className="block text-sm sm:text-base md:text-lg lg:text-xl font-medium text-gray-500 mt-3 tracking-[-0.01em] leading-snug" data-id="element-210">
                Even if you're starting from zero
              </span>
            </h1>

            <p className="text-xs sm:text-sm md:text-[15px] text-gray-400 max-w-md mb-6 animate-fade-in-up delay-200 leading-[1.7] tracking-[0.01em]" data-id="element-211">
              Get a done-for-you channel designed to grow, monetize, and earn.
              No face, no filming, no guesswork.
            </p>

            <div className="flex flex-col gap-2.5 mb-7 animate-fade-in-up delay-300 w-full" data-id="element-212">
              {['Data-backed niche & channel strategy', 'Done-for-you content production', 'Built for fast monetization & scale'].map((item, i) => <div key={i} className="flex items-center gap-2.5 text-xs sm:text-sm font-medium text-gray-300 justify-center lg:justify-start" data-id="element-213">
                  <div className="bg-green-500/20 p-0.5 rounded-full flex-shrink-0" data-id="element-214">
                    <Check className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-green-500" data-id="element-215" />
                  </div>
                  <span data-id="element-216">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col items-center lg:items-start gap-2.5 animate-fade-in-up delay-300 w-full sm:w-auto" data-id="element-217">
              <GlowButton className="w-full sm:w-auto" onClick={handleBookingClick} data-id="element-218">
                Book My ₹500 Strategy Call
              </GlowButton>
              <p className="label-caps text-[9px] sm:text-[10px] text-gray-500 tracking-[0.12em]" data-id="element-219">
                One-time ₹500 consultation fee. Fully worth it.
              </p>
            </div>
          </div>

          <div className="relative w-full flex justify-center lg:justify-end animate-fade-in-up delay-200 mt-4 lg:mt-0" data-id="element-220">
            <AnalyticsDashboard data-id="element-221" />
          </div>
        </div>
      </section>

      <ResultsSection data-id="element-222" />

      {/* CTA Section */}
      <section className="py-12 md:py-20 px-4 relative overflow-hidden" data-id="element-223">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-50" data-id="element-224" />

        <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-225">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold tracking-[-0.03em] mb-1 md:mb-2 text-white" data-id="element-226">
            Ready to Launch Your
          </h2>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold tracking-[-0.03em] mb-8 md:mb-10" data-id="element-227">
            <span className="text-gradient" data-id="element-228">Faceless Channel?</span>
          </h2>

          <GlassCard className="mb-8 max-w-md mx-auto text-left" data-id="element-229">
            <div className="text-center mb-6" data-id="element-230">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-231">
                ₹500 Strategy Call
              </h3>
              <p className="text-xs text-gray-400" data-id="element-232">What you get on the call:</p>
            </div>
            <div className="flex flex-col gap-3" data-id="element-233">
              {['Personalized niche analysis', 'Custom monetization roadmap', 'Channel setup blueprint', '30-min 1-on-1 with an expert'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-234">
                  <div className="bg-blue-500/20 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-235">
                    <Check className="w-3 h-3 text-blue-400" data-id="element-236" />
                  </div>
                  <span className="text-sm text-gray-300" data-id="element-237">{item}</span>
                </div>)}
            </div>
          </GlassCard>

          <div className="flex flex-col items-center gap-3 md:gap-4" data-id="element-238">
            <GlowButton className="w-full sm:w-auto" onClick={handleBookingClick} data-id="element-239">
              Book My ₹500 Strategy Call
            </GlowButton>

            <p className="label-caps text-[9px] md:text-[10px] text-gray-500 max-w-sm mx-auto tracking-[0.12em]" data-id="element-240">
              Serious creators only. This filters for commitment.
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-241" />
      </section>

      <footer className="py-8 text-center text-sm text-muted-foreground border-t border-white/5 bg-[#0a0a0f]" data-id="element-242">
        <p data-id="element-243">© 2026 Faceless YouTube System. All rights reserved.</p>
      </footer>
    </main>;
}